import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const catalogHealthViewAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.catalogHealth],
}
